import { keyframes } from '@emotion/react';

/**
 *  The glow animation is used to highlight a player button
 *  when its action is triggered via keyboard shortcut.
 * */
export const glow = keyframes`
 0%,
 75% {
   opacity: 0.8;
 }

 25% {
   opacity: 0.9;
 }

 50% {
   opacity: 1;
 }

 100% {
   opacity: 0.7;
 }
`;
